
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 17.679V8.836l15.644.042v8.8H1.5zM4.898 3.706v.924a.75.75 0 001.5 0v-.924h5.79v.924a.75.75 0 001.5 0v-.924h3.456v3.672L1.5 7.336v-3.63h3.398zm8.79-1.5V.75a.75.75 0 10-1.5 0v1.456h-5.79V.75a.75.75 0 00-1.5 0v1.456H1.5a1.5 1.5 0 00-1.5 1.5v13.973a1.5 1.5 0 001.5 1.5h15.644a1.5 1.5 0 001.5-1.5V3.706a1.5 1.5 0 00-1.5-1.5h-3.456z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    